import {post, get} from '@/utils/request'

/**
 * 获取直降款列表数据
 */
export function getListAPI(data) {
	return post({
		data,
		url: 'tbs/reduced-fee/list'
	})
}

/**
 * 获取直降款统计数据
 */
export function getStatAPI(data) {
	return post({
		data,
		url: 'tbs/reduced-fee/stat',
	})
}

/**
 * 获取直降款统计数据
 */
export function getDetailAPI(data) {
	return post({
		data,
		url: 'tbs/reduced-fee/detail',
	})
}

/**
 * 获取直降款统计数据
 */
export function getStoresAPI(data) {
	return get({
		data,
		url: 'tbs/reduced-fee/stores',
	})
}

/**
 * 获取直降款统计数据
 */
export function getAdvancePlayerAPI(data) {
	return get({
		data,
		url: 'tbs/reduced-fee/advance-payer',
	})
}


// 对账单导入
export function importAccountStatement(data) {
    return post({
        data,
        url: 'tbs/reduced-fee/uploadBilling'
    })
}

// 支付单导入
export function uploadPaymentForm(data) {
    return post({
        data,
        url: 'tbs/reduced-fee/uploadPaymentForm'
    })
}